var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/progression-arrow.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"c-progression-arrow\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"-455.8 241.5 41.2 81\" enable-background=\"new -455.8 241.5 41.2 81;\" xml:space=\"preserve\" aria-labelledby=\"progression-arrow-title-next\">\n\t<title id=\"progression-arrow-title-next\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["pagination-arrow-image"])), env.opts.autoescape);
output += "\n    </title>\n    <g>\n\t\t<path d=\"M-454.8,318.6c-0.8,0.8-0.8,2,0,2.8c0.8,0.8,1.9,0.8,2.6,0l36.8-39.4l-36.8-39.3c-0.8-0.8-1.9-0.8-2.6,0\n\t\t\tc-0.8,0.8-0.8,2,0,2.8l34.1,36.5L-454.8,318.6z\"></path>\n\t</g>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/progression-arrow.j2"] , dependencies)